import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Card,
  Input,
  CardHeader,
  CardBody,
  Row,
  Col,
  Table,
  ButtonGroup,
  Modal,
} from 'reactstrap';
import { algoliaAppID, algoliaSearchID } from '../../Utilities/algoliaKeys'
import Slide from '@mui/material/Slide';

import SearchIcon from '@mui/icons-material/Search';
import NotificationAlert from 'react-notification-alert';
import styles from './QuestionTest.module.css';
import KeyboardArrowLeftSharpIcon from '@mui/icons-material/KeyboardArrowLeftSharp';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import { Edit, Delete } from '@mui/icons-material';
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  DialogActions,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import { db } from '../../MY_LOGIN_AND_SIGNUP/db/config';
import { useLocation, useNavigate } from 'react-router-dom';
import AddQuizModal from './AddQuizModal';
import EditQuizModal from './EditQuizModal';
import VisibilityIcon from '@mui/icons-material/Visibility';
import firebase from 'firebase';
import ViewQuestionModal from './ViewQuestionModal';
import AttemptedUserList from './QuizReportAdmin/AttemptedUserList';
import AssignQuiz from './AssignQuiz';
import { InlineMath } from 'react-katex';
import algoliasearch from 'algoliasearch';

function CreateExcelQuestionV2() {
  const searchClient = algoliasearch(algoliaAppID, algoliaSearchID);
  const questionV2SearchIndex = searchClient.initIndex('Question_Search');
  const quizTestIndexing = searchClient.initIndex("Quiz_test_Search");
  
  const notifi = useRef();
  const navigate = useNavigate();
  const location = useLocation();
  const [currentUser, setCurrentUser] = useState();
  const [teacherList, setTeacherList] = useState([]);
  const [selectedTeacher, setSelectedTeacher] = useState({});
  const [pageSnapshots, setPageSnapshots] = useState([]);
  const [fetchSubject, setFetchSubject] = useState([]);
  const [currentSubject, setCurrentSubject] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [isModalVisible, setIsModalVisible] = useState(false);

  const notification = React.createRef();
  const [loading, setLoading] = useState(false);
  const [isSearched, setisSearched] = useState(false);
  
  const [searchQuery, setSearchQuery] = useState('');
  const [active, setactive] = useState(false);
  const [quizQuestionData, setquizQuestionData] = useState([]);
  const [quizDate, setquizDate] = useState([]);
  const [lastVisible, setLastVisible] = useState();
  const [firstVisible, setFirstVisible] = useState(null);
  const [isPrev, setIsPrev] = useState(false);

  const [hasNextPage, setHasNextPage] = useState(false);

  
  const [attemptedUserListState, setAttemptedUserListState] = useState({
    isOpen: false,
    quizName: '',
    quizId: '',
  });
  const [isViewQuestionModalOpen, setIsViewQuestionModalOpen] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState({});
  const [open, setOpen] = useState(false);
  const [assignQuizData, setAssignQuizData] = useState({
    isOpen: false,
    quizName: '',
    quizId: '',
  });

  const [linkedQuizzes, setLinkedQuizzes] = useState([]);
  const handleClose = () => {
    setOpen(false);
    setLinkedQuizzes([]);
  };

  const toggleViewModal = (question) => {
    setSelectedQuestion(question);
    setIsViewQuestionModalOpen(!isViewQuestionModalOpen);
  };

  const handleNavigateToQuizQuestion = (id, quizName, question) => {
    console.log('testNavigate', question);
    const queryParams = new URLSearchParams({
      id: id,
    }).toString();
    navigate(`/admin/quizQuestionList?${queryParams}`, { state: { quizName, language: question?.primaryLanguage } });
  };

  const [allCheckedQuiz, setAllCheckedQuiz] = useState(false);
  const [allCheckedQuestion, setAllCheckedQuestion] = useState(false);
  const [selectedQuestions, setSelectedQuestions] = useState([]);
  const [selectedQuizzes, setSelectedQuizzes] = useState([]);

  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction='up' ref={ref} {...props} />;
  });

  const getQuizBatches = async () => {
    try {
      // Fetch all quiz documents from the "AssignedQuizTests" collection
      const quizQuerySnapshot = await db.collection('AssignedQuizTests').get();
      const quizBatchesData = {};

      // Iterate over each quiz document
      for (const quizDoc of quizQuerySnapshot.docs) {
        const quizId = quizDoc.id; // Mock document ID

        // Get the batches directly from the quiz document
        const quizData = quizDoc.data();
        const batches = quizData.batches || []; // Ensure batches exist

        // Map the batches into the required format
        const formattedBatches = batches.map((batch) => ({
          label: batch.batchName,
          value: batch.batchId,
        }));

        // Store the fetched batches by quizId
        quizBatchesData[quizId] = formattedBatches;
      }

      setSelectedBatchesByQuiz(quizBatchesData); // Set the state with the fetched data
    } catch (error) {
      console.error('Error fetching quiz batches:', error);
    }
  };

  const getCurrentUser = () => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        db.collection('zSystemUsers')
          .doc(user.uid)
          .get()
          .then((query) => {
            let data = query.data();
            if (data?.isTeacher) {
              setSelectedTeacher({
                id: data._uniqueID,
                batchIds: data.isBatchManage || [],
                name: data.firstname + ' ' + data.lastname,
              });
            }
            setCurrentUser({
              isTeacher: data?.isTeacher || false,
              createdBy: data._uniqueID,
              creatorName: data.firstname + ' ' + data.lastname,
              isBatchManage: data?.isBatchManage || [],
            });
          });
      }
    });
  };

  const getTeacher = async () => {
    try {
      const userSnapshot = await db
        .collection('zSystemUsers')
        .where('isTeacher', '==', true)
        .where('status', '==', 0)
        .get();

      let teacher = userSnapshot.docs.map((doc) => ({
        id: doc.id,
        batchIds: doc.data().isBatchManage,
        name: doc.data().firstname + ' ' + doc.data().lastname,
      }));
      // if(teacher)
      setTeacherList(teacher);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (location?.state?.redirect == 'quiz') {
      setactive(true);
    }
    getCurrentUser();
    getTeacher();
    getSubjectDetail();
    getQuizBatches();
    getBatchDetail();
  }, []);

  useEffect(() => {
    if (!currentUser?.createdBy) return;
    if (!active) {
      getQuestions(searchQuery, isPrev);
    } else {
      getQuiz(searchQuery, isPrev);
    }
  }, [
    currentSubject,
    currentPage,
    limit,
    selectedTeacher,
    active,
    currentUser,
  ]);

  useEffect(() => {
    setLimit(10);
    setCurrentPage(1);
    setSelectedQuestions([]);
    setSelectedQuizzes([]);
    setAllCheckedQuestion(false);
    setAllCheckedQuiz(false);
  }, [selectedTeacher, active]);

  const [fetchBatch, setFetchBatch] = useState([]);
  const [selectedBatchesByQuiz, setSelectedBatchesByQuiz] = useState({});

  const getBatchDetail = async () => {
    try {
      const querySnapshot = await db
        .collection('Batch')
        .orderBy('createdAt', 'desc')
        .get();
      const batches = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setFetchBatch(batches);
    } catch (error) {
      console.error('Error fetching batch details:', error);
    }
  };

  const handleBatchChange = (quizId, selectedOptions) => {
    setSelectedBatchesByQuiz((prevState) => ({
      ...prevState,
      [quizId]: selectedOptions, // Store selected options by quizId
    }));
  };

  const saveQuizBatchesToDB = async (quizId, selectedBatches) => {
    const quizDocRef = db.collection('AssignedQuizTests').doc(quizId);

    // Prepare the quiz data with selected batches
    const quizData = {
      QuizTestId: quizId,
      status: 0, // 0 represents selected status
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      id: quizDocRef.id, // Add the document's ID to the quiz document
      batches: selectedBatches.map((batch) => ({
        batchId: batch.value,
        batchName: batch.label,
        status: 0, // 0 represents selected
      })),
      batchIds: selectedBatches.map((batch) => batch.value),
    };

    // Create or update the quiz document
    await quizDocRef.set(quizData, { merge: true });

    // Handle deselected batches if needed
    const previousSelectedBatches = selectedBatchesByQuiz[quizId] || [];
    const previousBatchIds = previousSelectedBatches.map(
      (batch) => batch.value
    );

    // Batches that were previously selected but are now deselected
    const deselectedBatchIds = previousBatchIds.filter(
      (batchId) =>
        !selectedBatches.map((batch) => batch.value).includes(batchId)
    );

    // Update the status of deselected batches if necessary
    if (deselectedBatchIds.length > 0) {
      await quizDocRef.update({
        batches: firebase.firestore.FieldValue.arrayRemove(
          ...deselectedBatchIds.map((batchId) => ({
            batchId,
            status: 1, // Mark as deselected
          }))
        ),
      });
    }
  };

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? '#272a3d' : 'black',
      padding: 10,
    }),
    control: () => ({
      display: 'none',
    }),
  };

  const getSubjectDetail = () => {
    db.collection('subjects')
      .where('primaryLanguages', '!=', null) // Ensures primaryLanguages is not null
      .where('status', '==', 0)
      .get()
      .then((querySnapshot) => {
        const subjects = [];
        querySnapshot.forEach((doc) => {
          subjects.push({ id: doc.id, ...doc.data() });
        });
        setFetchSubject(subjects);
        // if (subjects[0]) setCurrentSubject(subjects[0].name);
      })
      .catch((error) => {
        console.error('Error fetching subjects: ', error);
      });
  };

  const setQuesDataWrapper = (data, searchQuery) => {
    try {
      console.log(data, 'checking data');
      // If data is a function, invoke it with quizQuestionData as an argument
      if (typeof data === 'function') data = data(quizQuestionData);

      // Extract and format the question data
      const extractQuestionV2 = data?.map((item) => {
        let question = item[item?.primaryLanguage];
        // let [optionA, optionB, optionC, optionD] = question?.options;
        return {
          id: item?.id,
          questionNumber: item?.questionNumber,
          questionLanguages: item?.questionLanguages,
          isSelected: item?.select,
          subject: item?.subject,
          topic: item?.topic,
          question: question?.question,
          correctOption: question?.correctOption,
          isTeacher: item?.isTeacher ? true : false,
          creatorName: item?.isTeacher ? item.creatorName : 'Admin',
          createdBy: item?.createdBy,
        };
      });
      setquizQuestionData(extractQuestionV2);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSearch = (searchString) => {
    if (active) {
      if (searchString == '') {
        getQuiz();
      } else {
        getQuiz(searchQuery);
      }
    } else {
      if (searchString == '') {
        getQuestions();
      } else {
        getQuestions(searchQuery);
      }
    }
  };

  const getQuiz = async (searchQuery, isPrev) => {
    console.log('searchString:', searchQuery, 'isPrev:', isPrev);
    setLoading(true);
    try {
      
      let baseQuery = db.collection('QuizTest').where('status', '==', 0);
      if (selectedTeacher?.id) {
        baseQuery = baseQuery.where('createdBy', '==', selectedTeacher.id);
      }

      let docs = [];
      let orderedQuery;
      console.log('isPrevisPrevisPrev', isPrev);

      if (searchQuery?.trim()) {
        setisSearched(true);
        let searchResuolt;
        // await quizTestIndexing.setSettings({
        //   attributesForFaceting: ['filterOnly(createdBy)'],
        // });
        if ( selectedTeacher?.id) {
          searchResuolt = await quizTestIndexing.search(searchQuery, {
            facetFilters: `createdBy:${selectedTeacher.id}`,
          });
        } else {
          searchResuolt = await quizTestIndexing.search(searchQuery)
        }
        // console.log(searchResuolt.hits, "searchResuolt", currentSubject)
        setquizDate(searchResuolt.hits);
        setHasNextPage(false);
        setLoading(false);
        return;
      } else {
        setisSearched(false);

        // **Handle regular pagination (forward/backward)**
        orderedQuery = baseQuery.orderBy('createdAt', 'desc');

        if (isPrev && firstVisible && currentPage > 1) {
          // **Fetch previous page**
          orderedQuery = orderedQuery
            .endBefore(firstVisible)
            .limitToLast(limit + 1);
        } else {
          // **Fetch next page**
          if (currentPage > 1 && lastVisible) {
            orderedQuery = orderedQuery.startAfter(lastVisible);
          }
          orderedQuery = orderedQuery.limit(limit + 1);
        }
      }

      const querySnapshot = await orderedQuery.get();
      docs = querySnapshot.docs;

      if (docs.length === 0) {
        console.warn('No quizzes found.');
        setquizDate([]);
        setHasNextPage(false);
        setLoading(false);
        return;
      }

      // **Determine hasNextPage & hasPrevPage**
      let hasNextPage = docs.length > limit;
      let hasPrevPage = currentPage > 1;

      if (hasNextPage) docs.pop(); // Remove the extra fetched document

      // **Map data**
      let data = docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
        select: false,
      }));

      // **Set pagination state**
      setFirstVisible(docs[0] || null);
      setLastVisible(docs[docs.length - 1] || null);
      setHasNextPage(hasNextPage);
      // setHasPrevPage(hasPrevPage); // Ensure backward navigation works
      setquizDate(data);
    } catch (err) {
      console.error('Error fetching quizzes:', err);
    } finally {
      setLoading(false);
    }
  };

  const getQuestions = async (searchQuery, isPrev) => {
    setLoading(true);
    try {
      let baseQuery;
      if (selectedTeacher.id) {
        if (currentSubject) {
          baseQuery = db
            .collection('QuestionsV2')
            .where('createdBy', '==', selectedTeacher.id)
            .where('subject', '==', currentSubject)
            .where('status', '==', 0);
        } else {
          baseQuery = db
            .collection('QuestionsV2')
            .where('createdBy', '==', selectedTeacher.id)
            .where('status', '==', 0);
        }
      } else {
        if (currentSubject) {
          baseQuery = db
            .collection('QuestionsV2')
            .where('subject', '==', currentSubject)
            .where('status', '==', 0);
        } else {
          baseQuery = db.collection('QuestionsV2').where('status', '==', 0);
        }
      }

      let docs = [];

      if (searchQuery) {
        setisSearched(true);
        let searchResuolt;
        if(currentSubject || selectedTeacher){
          // await questionV2SearchIndex.setSettings({
          //   attributesForFaceting: ['filterOnly(subject)', 'filterOnly(createdBy)'],
          // });
          const facetFilters = [];

          if (currentSubject) {
            facetFilters.push(`subject:${currentSubject}`);
          }
          if (selectedTeacher?.id) {
            facetFilters.push(`createdBy:${selectedTeacher.id}`);
          }

            searchResuolt =    await questionV2SearchIndex.search(searchQuery, {
              facetFilters: facetFilters,
            });
        }else{
          searchResuolt = await questionV2SearchIndex.search(searchQuery)
        }
        console.log(searchResuolt.hits, "searchResuolt",currentSubject)
        setQuesDataWrapper(searchResuolt.hits, searchQuery);
        setLoading(false);
        return
      } else {
        setisSearched(false);

        // Regular pagination (no search)
        let orderedQuery = baseQuery
          .orderBy('questionNumber', 'asc')
          .limit(limit + 1);
        if (currentPage > 1 && lastVisible) {
          orderedQuery = orderedQuery.startAfter(lastVisible);
        }

        let querySnapshot = await orderedQuery.get();
        docs = querySnapshot.docs;
      }

      if (docs.length === 0) {
        setLoading(false);
        setQuesDataWrapper([], searchQuery);
        setHasNextPage(false);
        return;
      }

      // Check if there are more results
      let hasNextPage = docs.length > limit;
      if (hasNextPage) {
        docs.pop(); // Remove extra document
      }

      // Map documents to data objects
      let data = docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
        select: false,
      }));

      // Store the last visible document for pagination
      setLastVisible(docs[docs.length - 1] || null);
      setHasNextPage(hasNextPage);
      setLoading(false);
      setQuesDataWrapper(data, searchQuery);
    } catch (err) {
      console.error('Error fetching questions:', err);
      setLoading(false);
    }
  };

  const deleteQuestionV2Handler = async (id) => {
    const confirmation = window.confirm('Do you want to delete this Question?');
    if (confirmation) {
      try {
        const quizTestRef = db.collection('QuizTest');

        const snapshot = await quizTestRef
          .where('quizQuestions', 'array-contains', id)
          .where('status', '==', 0)
          .get();
        if (snapshot.empty) {
          await db.collection('QuestionsV2').doc(id).update({ status: 1 });
          getQuestions();
          return null;
        }
        const quizzes = [];
        snapshot.forEach((doc) => {
          quizzes.push(doc.data().name || doc.id);
        });
        setLinkedQuizzes(quizzes);
        setOpen(true); // Open the dialog
        setLoading(false);
        const loadingIndicator = document.querySelector('#loading-indicator');
        if (loadingIndicator) loadingIndicator.style.display = 'none';
      } catch (error) {
        setLoading(false);
        console.error('Error deleting question:', error);
      }
    } else {
      console.log('Delete operation canceled');
      setLoading(false);
    }
  };

  const handleBulkDeleteQuestions = async () => {
    if (selectedQuestions.length === 0) {
      notify('Please select questions to delete', true);
      return;
    }

    const confirmation = window.confirm(
      `Do you want to delete ${selectedQuestions.length} question(s)?`
    );
    if (!confirmation) return;

    try {
      const quizTestRef = db.collection('QuizTest');
      let linkedQuizzes = [];

      const loadingIndicator = document.querySelector('#loading-indicator');
      if (loadingIndicator) loadingIndicator.style.display = 'flex';

      // Check if any selected question is linked to a quiz
      for (const questionId of selectedQuestions) {
        const snapshot = await quizTestRef
          .where('quizQuestions', 'array-contains', questionId)
          .where('status', '==', 0)
          .get();

        if (!snapshot.empty) {
          snapshot.forEach((doc) => {
            const quizName = doc.data().name || doc.id;
            if (!linkedQuizzes.includes(quizName)) {
              linkedQuizzes.push(quizName);
            }
          });
        }
      }

      if (linkedQuizzes.length > 0) {
        setLinkedQuizzes(linkedQuizzes);
        setOpen(true);
        setLoading(false);
        const loadingIndicator = document.querySelector('#loading-indicator');
        if (loadingIndicator) loadingIndicator.style.display = 'none';
        return;
      }

      // Delete all selected questions
      const batch = db.batch();
      selectedQuestions.forEach((questionId) => {
        const questionRef = db.collection('QuestionsV2').doc(questionId);
        batch.update(questionRef, { status: 1 });
      });

      await batch.commit();
      if (loadingIndicator) loadingIndicator.style.display = 'none';
      notify(`${selectedQuestions.length} question(s) deleted successfully`, false);
      setSelectedQuestions([]);
      setAllCheckedQuestion(false);
      getQuestions();
    } catch (error) {
      console.error('Error deleting questions:', error);
      notify('Error deleting questions', true);
      setLoading(false);
    }
  };

  const handleBulkDeleteQuizzes = async () => {
    if (selectedQuizzes.length === 0) {
      notify('Please select quizzes to delete', true);
      return;
    }

    const confirmation = window.confirm(
      `Do you want to delete ${selectedQuizzes.length} quiz(zes)?`
    );
    if (!confirmation) return;

    try {
      const batch = db.batch();

      const loadingIndicator = document.querySelector('#loading-indicator');
      if (loadingIndicator) loadingIndicator.style.display = 'flex';

      selectedQuizzes.forEach((quizId) => {
        const quizRef = db.collection('QuizTest').doc(quizId);
        const systemStoreRef = db.collection('zSystemStore').doc(quizId);
        batch.update(quizRef, { status: 1 });
        batch.delete(systemStoreRef);
      });

      await batch.commit();
      if (loadingIndicator) loadingIndicator.style.display = 'none';
      notify(`${selectedQuizzes.length} quiz(zes) deleted successfully`, false);

      setSelectedQuizzes([]);
      setAllCheckedQuiz(false);
      getQuiz();
    } catch (error) {
      console.error('Error deleting quizzes:', error);
      notify('Error deleting quizzes', true);
    }
  };

  const handleSelectAllQuestions = (checked) => {
    setAllCheckedQuestion(checked);
    if (checked) {
      const allIds = quizQuestionData.map((q) => q.id);
      setSelectedQuestions(allIds);
    } else {
      setSelectedQuestions([]);
    }
  };

  const handleSelectAllQuizzes = (checked) => {
    setAllCheckedQuiz(checked);
    if (checked) {
      const allIds = quizDate.map((q) => q.id);
      setSelectedQuizzes(allIds);
    } else {
      setSelectedQuizzes([]);
    }
  };

  const handleSelectQuestion = (questionId, checked) => {
    if (checked) {
      setSelectedQuestions([...selectedQuestions, questionId]);
    } else {
      setSelectedQuestions(selectedQuestions.filter((id) => id !== questionId));
      setAllCheckedQuestion(false);
    }
  };

  const handleSelectQuiz = (quizId, checked) => {
    if (checked) {
      setSelectedQuizzes([...selectedQuizzes, quizId]);
    } else {
      setSelectedQuizzes(selectedQuizzes.filter((id) => id !== quizId));
      setAllCheckedQuiz(false);
    }
  };

  const handleEditQuestion = async (updatedQuestion) => {
    try {
      updatedQuestion.primaryQuestion = updatedQuestion[
        updatedQuestion?.primaryLanguage
      ]?.question
        ?.toLowerCase()
        .trim();
      updatedQuestion.topic = updatedQuestion?.topic;
      updatedQuestion.questionLanguages =
        updatedQuestion?.questionLanguages?.map((lang) => {
          return lang?.toLowerCase()?.trim();
        });

      // Reference the specific document in the QuestionsV2 collection using the question's ID
      const questionRef = db.collection('QuestionsV2').doc(updatedQuestion.id);
      // Update the document in the Firestore database
      await questionRef.update({
        ...updatedQuestion,
        updatedAt: new Date(),
      });
      toggleModal();
      if (!active) {
        getQuestions();
      } else {
        getQuiz();
      }
      console.log('Question updated successfully in the database');
    } catch (error) {
      console.error('Error updating question:', error);
    } finally {
      toggleModal(); // Close the modal after submission
    }
  };

  const toggleModal = () => {
    setIsModalOpen((prev) => !prev);
  };

  // const deleteQuizHandler = async (quizId) => {
  //   try {
  //     const quizRef = db.collection('QuizTest').doc(quizId);

  //     // Update the status to 1
  //     await quizRef.update({ status: 1 });

  //     console.log(`Mock with ID ${quizId} has been updated to status: 1`);
  //     getQuiz();
  //   } catch (error) {
  //     console.error('Error updating quiz status:', error);
  //   }
  // };

  const deleteQuizHandler = async (quizId) => {
    try {
      const quizRef = db.collection('QuizTest').doc(quizId);
      const systemStoreRef = db.collection('zSystemStore').doc(quizId);

      // Update the status to 1 in QuizTest
      await quizRef.update({ status: 1 });
      console.log(`Mock with ID ${quizId} has been updated to status: 1`);

      // Delete entry from zSystemStore based on itemID
      const docSnapshot = await systemStoreRef.get();
      if (docSnapshot.exists) {
        await systemStoreRef.delete();
        console.log(`Entry with itemID ${quizId} deleted from zSystemStore.`);
      } else {
        console.log(`No entry found for itemID ${quizId} in zSystemStore.`);
      }

      getQuiz(); // Refresh quiz list
    } catch (error) {
      console.error(
        'Error updating quiz status or deleting from zSystemStore:',
        error
      );
    }
  };

  const [isAddQuizModalOpen, setIsAddQuizModalOpen] = useState(false);

  const toggleAddQuizModalModal = () => {
    setIsAddQuizModalOpen(!isAddQuizModalOpen);
  };

  const notify = (msg, err) => {
    let color = err === false ? 'success' : 'danger';
    let options = {
      type: color,
      place: 'tr',
      message: (
        <div>
          <div>
            <b>{err === false ? 'Success' : 'Error'}</b> - {msg}.
          </div>
        </div>
      ),
      icon: 'tim-icons icon-bell-55',
      autoDismiss: 6,
    };
    if (notifi.current) {
      notifi.current.notificationAlert(options);
    }
  };

  const handleSaveQuiz = async (quizData) => {
    try {

      console.log('quizData99', quizData);
      // Show loading indicator
      document.querySelector('#loading-indicator').style.display = 'flex';

      if (!quizData.quizTime) {
        notify(
          'Something went wrong. Please refresh the page and try again.',
          true
        );
        document.querySelector('#loading-indicator').style.display = 'none';
        return;
      }

      const db = firebase.firestore();
      const quizId = quizData.id || db.collection('QuizTest').doc().id;
      const quizRef = db.collection('QuizTest').doc(quizId);
      const systemStoreRef = db.collection('zSystemStore').doc(quizId); // Use the same ID for consistency

      const batch = db.batch();

      // Save quiz in `QuizTest`
      batch.set(quizRef, {
        id: quizId,
        name: quizData.name,
        rule: quizData.rule,
        quizTime: quizData?.quizTime,
        positiveMarks: quizData.positiveMarks,
        negativeMarks: quizData.negativeMarks,
        numberOfQuation: quizData.numberOfQuation,
        price: quizData.price || 0,
        status: 0,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        subjectWeightage: quizData.subjectWeightage,
        ...currentUser,
      });

      // Save quiz details in `zSystemStore`
      batch.set(systemStoreRef, {
        itemID: quizId,
        title: quizData.name,
        instructions: quizData.rule || '',
        numberOfQuestions: quizData.numberOfQuation,
        price: quizData.price,
        rating: quizData.rating || 0,
        timePerQues: quizData.quizTime,
        totalTime: quizData.quizTime * quizData.numberOfQuation,
        type: 'quiz',
        withoutTimer: quizData.withoutTimer || false,
        mockTest: quizData.mockTest || false,
        quizCover: quizData.quizCover || '',
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        lastUpdatedAt: firebase.firestore.FieldValue.serverTimestamp(),
      });

      // Fetch all questions before writing to Firestore
      const questionPromises = quizData.subjectWeightage.map(
        async (subject) => {

          console.log('subjectWeightage', subject.subjectQuestion, quizData.numberOfQuation, subject);
          const numQuestions = Math.round(
            (subject.subjectQuestion / quizData.numberOfQuation) *
              quizData.numberOfQuation
          );
          console.log('numQuestions', numQuestions);
          const questions = await fetchQuestionsForSubject(
            subject.subjectName,
         
            numQuestions,
          subject.TopicWeightage,
          );

          console.log('qS2', questions);


      

          return {
            subject: subject.subjectName,
            questions: questions.slice(0, numQuestions),
          };
        }
      );

      // Wait for all questions to be fetched
      const questionsData = await Promise.all(questionPromises);
      let quizQuestions = [];

      // Add questions to Firestore
      questionsData.forEach(({ subject, questions }) => {
        console.log('qST', questions);
        questions.forEach((question) => {
          const questionId = quizRef.collection('QuationCollection').doc().id;
          const questionRef = quizRef
            .collection('QuationCollection')
            .doc(questionId);

          batch.set(questionRef, {
            QuationsV2Id: question.id,
            subject: subject,
            id: questionId,
          });
          quizQuestions.push(question.id);
        });
      });

      batch.update(quizRef, { quizQuestions });

      // Commit all writes in a single batch
      await batch.commit();
      
      // Hide loading indicator
      document.querySelector('#loading-indicator').style.display = 'none';
      
      notify('Mock Created successfully', false);
      getQuiz();
      console.log('Quiz and zSystemStore data saved successfully');
    } catch (error) {
      console.error('Error in handleSaveQuiz:', error);
      
      // Hide loading indicator on error
      document.querySelector('#loading-indicator').style.display = 'none';
      
      // Check if it's an insufficient questions error
      if (error.message && error.message.includes('Insufficient questions')) {
        // Display the detailed error message to the user
        alert(error.message);
      } else {
        // Generic error message for other errors
        notify('Error creating quiz. Please try again.', true);
      }
      
      // Re-throw the error so the modal can catch it and stay open
      throw error;
    }
  };

  // Example function to fetch questions based on the subject and weightage
  const fetchQuestionsForSubject = (subject, numQuestions, topicWeightage) => {
    return new Promise(async (resolve, reject) => {
      try {
        console.log('=== fetchQuestionsForSubject ===');
        console.log('Subject:', subject);
        console.log('Total numQuestions needed:', numQuestions);
        console.log('TopicWeightage:', topicWeightage);

        // If topicWeightage is provided and has topics, fetch questions per topic
        if (topicWeightage && topicWeightage.length > 0) {
          const allQuestions = [];
          const insufficientTopics = []; // Track topics with insufficient questions

          // Fetch questions for each topic based on its weightage
          for (const topicConfig of topicWeightage) {
            const topicName = topicConfig.name;
            const questionsNeeded = topicConfig.noOfQuestion || 0;

            console.log(`Fetching ${questionsNeeded} questions for topic: "${topicConfig.name}"`);

            const querySnapshot = await db
              .collection('QuestionsV2')
              .where('subject', '==', subject)
              .where('topic', '==', topicName)
              .where('status', '==', 0)
              .orderBy('questionNumber', 'asc')
              .get();

            const availableCount = querySnapshot.docs.length;
            console.log(`Found ${availableCount} total questions for topic "${topicConfig.name}"`);

            // Check if we have enough questions for this topic
            if (availableCount < questionsNeeded) {
              insufficientTopics.push({
                topic: topicConfig.name,
                needed: questionsNeeded,
                available: availableCount,
                missing: questionsNeeded - availableCount
              });
            }

            // Map all questions for this topic
            const topicQuestions = querySnapshot.docs.map((doc) => {
              const question = doc.data();
              return {
                id: doc.id,
                subject: question.subject,
                question: question.question,
                correctOption: question.correctOption,
                options: question.options,
                difficulty: question.difficulty,
                primaryLanguage: question.primaryLanguage,
                questionLanguages: question.questionLanguages,
                questionNumber: question.questionNumber,
                status: question.status,
                topic: question.topic,
                createdAt: question.createdAt,
              };
            });

            // Shuffle and select only the required number of questions for this topic
            const shuffled = topicQuestions.sort(() => Math.random() - 0.5);
            const selectedQuestions = shuffled.slice(0, questionsNeeded);

            console.log(`Selected ${selectedQuestions.length} questions from topic "${topicConfig.name}"`);

            allQuestions.push(...selectedQuestions);
          }

          // If any topics have insufficient questions, throw an error
          if (insufficientTopics.length > 0) {
            const errorMessages = insufficientTopics.map(t => 
              `topic "${t.topic}": needs ${t.needed} questions, but only ${t.available} available (${t.missing} more needed or Select Other topics)`
            );
            const errorMessage = `Insufficient questions for the following topics:\n\n${errorMessages.join('\n')}`;
            console.error(errorMessage);
            reject(new Error(errorMessage));
            return;
          }

          console.log(`Total questions selected from all topics: ${allQuestions.length}`);
          console.log('=== END fetchQuestionsForSubject ===');
          resolve(allQuestions);
        } else {
          // No topic weightage, fetch random questions from the entire subject
          console.log('No topic weightage provided, fetching random questions from entire subject');

          const querySnapshot = await db
            .collection('QuestionsV2')
            .where('subject', '==', subject)
            .where('status', '==', 0)
            .orderBy('questionNumber', 'asc')
            .get();

          const availableCount = querySnapshot.docs.length;
          
          // Check if we have enough questions
          if (availableCount < numQuestions) {
            const errorMessage = `Insufficient questions for subject "${subject}": needs ${numQuestions} questions, but only ${availableCount} available (${numQuestions - availableCount} more needed)`;
            console.error(errorMessage);
            reject(new Error(errorMessage));
            return;
          }

          const questions = querySnapshot.docs.map((doc) => {
            const question = doc.data();
            return {
              id: doc.id,
              subject: question.subject,
              question: question.question,
              correctOption: question.correctOption,
              options: question.options,
              difficulty: question.difficulty,
              primaryLanguage: question.primaryLanguage,
              questionLanguages: question.questionLanguages,
              questionNumber: question.questionNumber,
              status: question.status,
              topic: question.topic,
              createdAt: question.createdAt,
            };
          });

          // Shuffle and select required number of questions
          const shuffled = questions.sort(() => Math.random() - 0.5);
          const selectedQuestions = shuffled.slice(0, numQuestions);

          console.log(`Selected ${selectedQuestions.length} random questions from subject`);
          console.log('=== END fetchQuestionsForSubject ===');
          resolve(selectedQuestions);
        }
      } catch (error) {
        console.error('Error fetching questions from QuestionsV2:', error);
        reject(error);
      }
    });
  };

  // Utility function to select a random question if only 1 is needed
  const getRandomQuestion = (questions) => {
    const randomIndex = Math.floor(Math.random() * questions.length);
    return questions[randomIndex];
  };

  const [isEditQuizModalOpen, setIsEditQuizModalOpen] = useState(false); // Tracks modal visibility
  const [quizToEdit, setQuizToEdit] = useState(null); // Holds the quiz being edited

  // Function to toggle modal visibility
  const toggleEditQuizModal = () => {
    setIsEditQuizModalOpen(!isEditQuizModalOpen);
    if (!isEditQuizModalOpen) {
      setQuizToEdit(null); // Reset quizToEdit when modal is closed
    }
  };

  // Function to handle edit action
  const handleEditQuiz = (quiz) => {
    setQuizToEdit(quiz);
    setIsEditQuizModalOpen(true); // Open the modal
  };

  // Function to update quiz (e.g., send to backend or update state)
  const updateQuiz = async (updatedQuiz) => {
    try {
      // Reference to the existing quiz document
      const quizRef = db.collection('QuizTest').doc(updatedQuiz.id);
      db.collection('zSystemStore')
        .doc(updatedQuiz.id)
        .update({
          title: updatedQuiz.name,
          price: updatedQuiz.price,
        })
        .then(() => {
          console.log('Document successfully updated!');
        })
        .catch((error) => {
          console.error('Error updating document: ', error);
        });

      // Update only `name`, `price`, and `quizTime`
      await quizRef.set(
        {
          name: updatedQuiz.name,
          price: updatedQuiz.price,
        },
        { merge: true }
      );
      console.log('Mock updated successfully');
      getQuiz();
      toggleEditQuizModal();
    } catch (error) {
      console.error('Error updating quiz:', error);
      alert('Failed to update quiz. Please try again.');
    }
  };

  const renderMixedContent = (text) => {
    let parts = text.split(/(\$[^$]+\$)/g);
    return parts.map((part, index) => {
      if (part.startsWith('$') && part.endsWith('$')) {
        let modifiedPart = part.replace(/\$/g, '');
        return <InlineMath key={index} math={modifiedPart} />;
      }
      return <span key={index} dangerouslySetInnerHTML={{ __html: part }} />;
    });
  };


  console.log('hindi1', quizQuestionData, currentSubject);

  return (
    <div className='content'>
      <NotificationAlert ref={notifi} />
      <Dialog open={open} onClose={handleClose} maxWidth='sm' fullWidth>
        <DialogTitle
          sx={{ bgcolor: 'primary.main', color: 'white', textAlign: 'center' }}
        >
          Cannot Delete Question
        </DialogTitle>

        <DialogContent>
          <DialogContentText
            sx={{
              fontSize: 16,
              fontWeight: 500,
              textAlign: 'center',
              color: 'text.primary',
              mb: 2,
            }}
          >
            This question is linked to the following quizzes. Please remove it
            from these quizzes first:
          </DialogContentText>

          <List
            sx={{ bgcolor: 'background.paper', borderRadius: 2, boxShadow: 1 }}
          >
            {linkedQuizzes.map((quiz, index) => (
              <ListItem key={index} divider>
                <ListItemText
                  primary={quiz}
                  primaryTypographyProps={{
                    fontWeight: 600,
                    color: 'text.secondary',
                  }}
                />
              </ListItem>
            ))}
          </List>
        </DialogContent>

        <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
          <Button
            onClick={handleClose}
            variant='contained'
            sx={{ px: 4, py: 1, fontSize: 16, borderRadius: 2 }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <div className='react-notification-alert-container'>
        <NotificationAlert ref={notification} />
      </div>
      <Row>
        <Col md='12'>
          <Card>
            <CardHeader className={styles.card_header}>
              <Col>
                <ButtonGroup>
                  <Button
                    className={active ? 'data' : 'btn-simple data'}
                    color='info'
                    size='sm'
                    onClick={() => {
                      setactive((prev) => !prev);
                      setAllCheckedQuestion(false);
                      setAllCheckedQuiz(false);
                      getQuiz();
                    }}
                  >
                    <span className='d-none d-sm-block d-md-block d-lg-block d-xl-block'>
                      Mock
                    </span>
                    <span className='d-block d-sm-none'>
                      <i className='tim-icons icon-single-02' />
                    </span>
                  </Button>

                  <Button
                    className={active ? 'btn-simple data' : 'data'}
                    color='info'
                    size='sm'
                    onClick={() => {
                      setactive((prev) => !prev);
                      getQuestions();
                      setAllCheckedQuestion(false);
                      setAllCheckedQuiz(false);
                    }}
                  >
                    <span className='d-none d-sm-block d-md-block d-lg-block d-xl-block'>
                      QUESTIONS
                    </span>
                    <span className='d-block d-sm-none'>
                      <i className='tim-icons icon-gift-2' />
                    </span>
                  </Button>
                </ButtonGroup>
              </Col>
              {active ? (
                  <>
                    {/* <Button color="info">
                                    Assign Mock
                                </Button> */}
                    <Button color='info' onClick={toggleAddQuizModalModal}>
                      Add Mock Exam
                    </Button>
                    {selectedQuizzes.length > 0 && (
                      <Button
                        color='danger'
                        onClick={handleBulkDeleteQuizzes}
                        style={{ marginLeft: '10px' }}
                      >
                        Delete Selected ({selectedQuizzes.length})
                      </Button>
                    )}
                  </>
              ) : (
                <>
                  <Button
                    color='info'
                    onClick={() => {
                      setIsModalVisible(true);
                      navigate('/admin/mathKeyboard');
                    }}
                  >
                    Create Mathematical Expression
                  </Button>
                  <Button
                    color='info'
                    onClick={() => {
                      setIsModalVisible(true);
                      navigate('/admin/addQuiz');
                    }}
                  >
                    Add Questions
                  </Button>
                  {selectedQuestions.length > 0 && (
                    <Button
                      color='danger'
                      onClick={handleBulkDeleteQuestions}
                      style={{ marginLeft: '10px' }}
                    >
                      Delete Selected ({selectedQuestions.length})
                    </Button>
                  )}
                </>
              )}
            </CardHeader>
            {!active ? (
              <CardBody>
                {/* Search and Pagination Controls */}
                <Row className='align-items-center'>
                  {/* Search Input and Button */}
                  <Col sm={8} className='d-flex align-items-center'>
                    <select
                      id='subject'
                      className='form-control'
                      value={currentSubject}
                      onChange={(e) => {
                        setIsPrev(false);
                        setCurrentSubject(e.target.value);
                        setCurrentPage(1);
                      }}
                      style={{
                        maxWidth: '200px',
                        height: '40px',
                        border: '1px solid rgb(42.67, 52.71, 82.83)',
                        borderRadius: '4px',
                        padding: '5px 10px',
                      }}
                    >
                      <option value=''>View All Subject</option>
                      {fetchSubject.map((subject) => (
                        <option key={subject.id} value={subject.name}>
                          {subject.name}
                        </option>
                      ))}
                    </select>
                    <select
                      id='teacher'
                      className='form-control'
                      value={selectedTeacher?.id || ''}
                      onChange={(e) => {
                        if (e.target.value != '') {
                          const currentTeacher = teacherList.find(
                            (teacher) =>
                              teacher.id.toString() === e.target.value
                          );
                          setSelectedTeacher(currentTeacher);
                        } else {
                          setSelectedTeacher([]);
                        }
                      }}
                      style={{
                        maxWidth: '200px',
                        border: '1px solid rgb(42.67, 52.71, 82.83)',
                        borderRadius: '4px',
                        padding: '5px 10px',

                        margin: '10px',
                      }}
                    >
                      <option value=''>View All Teacher Questions </option>
                      {teacherList.map((teacher) => (
                        <option key={teacher.id} value={teacher.id}>
                          {teacher.name}
                        </option>
                      ))}
                    </select>
                    <Input
                      type='text'
                      name='search'
                      placeholder='Search Question'
                      onChange={(e) => {
                        setSearchQuery(e.target.value);
                        if (e.target.value == '') {
                          setIsPrev(false);
                          setCurrentPage(1);
                          handleSearch(e.target.value);
                        }
                      }}
                      style={{
                        flex: 1,
                        marginRight: '10px',
                        height: '40px',
                        borderRadius: '4px',
                      }}
                    />
                    <Button
                      color='info'
                      onClick={() => {
                        setIsPrev(false);
                        setCurrentPage(1);
                        setTimeout(() => {
                          handleSearch();
                        }, 1);
                      }}
                      style={{
                        height: '40px',
                        padding: '0 15px',
                      }}
                    >
                      <SearchIcon />
                    </Button>
                  </Col>

                  {/* Pagination Controls */}
                  {!isSearched &&  <Col
                    sm={4}
                    className='d-flex justify-content-end align-items-center'
                  >
                    <p
                      style={{
                        marginRight: '15px',
                        marginBottom: '0',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {currentPage * limit - (limit - 1)}-{currentPage * limit}
                    </p>
                    <IconButton style={{ outline: 'none' }}>
                      {currentPage > 1 ? (
                        <KeyboardArrowLeftSharpIcon
                          style={{ color: '#fff' }}
                          onClick={() => {
                            setIsPrev(true);
                            setCurrentPage(currentPage - 1);
                          }}
                        />
                      ) : (
                        ''
                      )}
                    </IconButton>

                    {hasNextPage ? (
                      <IconButton style={{ outline: 'none' }}>
                        <KeyboardArrowRightSharpIcon
                          style={{ color: '#fff' }}
                          onClick={() => {
                            setIsPrev(false);
                            setCurrentPage(currentPage + 1);
                          }}
                        />
                      </IconButton>
                    ) : (
                      ''
                    )}
                 {!isSearched && <select
                      className='form-control'
                      onChange={(e) => {
                        setIsPrev(false);
                        setLimit(parseInt(e.target.value));
                        setCurrentPage(1);
                      }}
                      style={{
                        maxWidth: '67px',
                        height: '40px',
                        color: '#fff', // White text
                        borderRadius: '4px',
                        marginLeft: '10px',
                      }}
                    >
                      <option value={10}>10</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>}
                  </Col>}
                </Row>

                {/* Mock Table */}
                {quizQuestionData?.length > 0 ? (
                  <Table className='tablesorter'>
                    <thead className='text-primary'>
                      <tr>
                        <th style={{ width: '50px', textAlign: 'center' }}>
                          <input
                            type='checkbox'
                            checked={allCheckedQuestion}
                            onChange={(e) => handleSelectAllQuestions(e.target.checked)}
                            style={{ cursor: 'pointer', width: '18px', height: '18px' }}
                          />
                        </th>
                        {/* <th style={{ width: '150px' }}>Question Range </th> */}
                        <th  style={{ width: '350px' }}>Question</th>
                        <th>Subject</th>
                        <th>Topic</th>
                        <th>Language</th>
                        <th>CreatedBy </th>
                        <th style={{ textAlign: 'center' }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {quizQuestionData.map((quiz, index) => (
                        <tr key={index}>
                          <td style={{ width: '50px', textAlign: 'center' }}>
                            <input
                              type='checkbox'
                              checked={selectedQuestions.includes(quiz.id)}
                              onChange={(e) => handleSelectQuestion(quiz.id, e.target.checked)}
                              style={{ cursor: 'pointer', width: '18px', height: '18px' }}
                            />
                          </td>
                          {/* <td style={{ width: '150px' }}>
                            {quiz?.questionNumber}
                          </td> */}
                          <td style={{ width: '350px' }} className={quiz.questionLanguages.includes('fganh')|| quiz.questionLanguages.includes('हिंदी') ? 'hinditext' : ''}>
                             {renderMixedContent(quiz?.question)}
                          </td>
                          <td>{quiz?.subject}</td>
                          <td className={quiz.questionLanguages.includes('fganh')|| quiz.questionLanguages.includes('हिंदी') ? 'hinditext' : ''}>{quiz?.topic}</td>
                          <td className={quiz.questionLanguages.includes('fganh')|| quiz.questionLanguages.includes('हिंदी') ? 'hinditext' : ''}>{quiz?.questionLanguages?.join(', ')}</td>
                          <td>{quiz?.creatorName}</td>
                          <td>
                            <div
                              style={{
                                display: 'flex',
                                padding: '0 6px',
                                gap: '6px',
                                justifyContent: 'center',
                              }}
                            >
                              <button
                                style={{
                                  color: 'white',
                                  border: '0',
                                  padding: '0 ',
                                  outline: 'none',
                                  background: 'transparent',
                                }}
                                onClick={() => {
                                  toggleViewModal(quiz);
                                }}
                                disabled={
                                  currentUser?.isTeacher
                                    ? currentUser.createdBy !== quiz.createdBy
                                    : false
                                }
                              >
                                <VisibilityIcon
                                  style={{ color: '#296ff6' }}
                                  sx={{
                                    opacity: currentUser?.isTeacher
                                      ? currentUser.createdBy == quiz.createdBy
                                        ? '1.0'
                                        : '0.5'
                                      : '1.0',
                                    cursor: currentUser?.isTeacher
                                      ? currentUser?.createdBy == quiz.createdBy
                                        ? 'pointer'
                                        : ''
                                      : 'pointer',
                                  }}
                                />
                              </button>

                              <button
                                style={{
                                  color: 'white',
                                  border: '0',
                                  padding: '0 ',
                                  outline: 'none',
                                  background: 'transparent',
                                }}
                                onClick={() => {
                                  navigate('/admin/editQuestion', {
                                    state: {
                                      fetchSubject: fetchSubject,
                                      questionDataToEdit: quiz,
                                    },
                                  });
                                }}
                                disabled={
                                  currentUser?.isTeacher
                                    ? currentUser.createdBy !== quiz.createdBy
                                    : false
                                }
                              >
                                <Edit
                                  style={{ color: '#247cf7' }}
                                  sx={{
                                    opacity: currentUser?.isTeacher
                                      ? currentUser?.createdBy == quiz.createdBy
                                        ? '1.0'
                                        : '0.5'
                                      : '1.0',
                                    cursor: currentUser?.isTeacher
                                      ? currentUser?.createdBy == quiz.createdBy
                                        ? 'pointer'
                                        : ''
                                      : 'pointer',
                                  }}
                                />
                              </button>

                              <button
                                style={{
                                  color: 'white',
                                  border: '0',
                                  padding: '0 ',
                                  outline: 'none',
                                  background: 'transparent',
                                }}
                                disabled={
                                  currentUser?.isTeacher
                                    ? currentUser?.createdBy !== quiz.createdBy
                                    : false
                                }
                                onClick={() => {
                                  deleteQuestionV2Handler(quiz?.id);
                                }}
                              >
                                <Delete
                                  style={{ color: 'red' }}
                                  sx={{
                                    opacity: currentUser?.isTeacher
                                      ? currentUser?.createdBy == quiz.createdBy
                                        ? '1.0'
                                        : '0.5'
                                      : '1.0',
                                    cursor: currentUser?.isTeacher
                                      ? currentUser?.createdBy == quiz.createdBy
                                        ? 'pointer'
                                        : ''
                                      : 'pointer',
                                  }}
                                />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                ) : (
                  <>
                    {!loading && (
                      <div
                        style={{
                          textAlign: 'center',
                          fontSize: '18px',
                          fontWeight: 'bold',
                          padding: '20px',
                          border: '1px solid #ddd',
                          borderRadius: '8px',
                          marginTop: '20px',
                        }}
                      >
                        {searchQuery
                          ? 'No Question Availabe For This Search'
                          : ' No Questions Available'}
                      </div>
                    )}
                  </>
                )}
              </CardBody>
            ) : (
              <CardBody>
                {/* Search and Pagination Controls */}
                <Row>
                  <Col sm={5}>
                    <div style={{ display: 'flex' }}>
                      <select
                        id='teacher'
                        className='form-control'
                        value={selectedTeacher?.id || ''}
                        onChange={(e) => {
                          if (e.target.value != '') {
                            const currentTeacher = teacherList.find(
                              (teacher) =>
                                teacher.id.toString() === e.target.value
                            );
                            setSelectedTeacher(currentTeacher);
                          } else {
                            setSelectedTeacher([]);
                          }
                        }}
                        style={{
                          maxWidth: '200px',
                          border: '1px solid rgb(42.67, 52.71, 82.83)',
                          borderRadius: '4px',
                          padding: '5px 10px',
                          margin: '10px',
                        }}
                      >
                        <option value=''>View All Teacher Mock </option>
                        {teacherList.map((teacher) => (
                          <option key={teacher.id} value={teacher.id}>
                            {teacher.name}
                          </option>
                        ))}
                      </select>

                      <Input
                        type='text'
                        style={{ marginTop: '10px' }}
                        name='search'
                        placeholder={active ? 'Search Mock' : 'Search Question'}
                        value={searchQuery}
                        onChange={(e) => {
                          setSearchQuery(e.target.value);
                          if (e.target.value == '') {
                            handleSearch(e.target.value);
                          }
                        }}
                      />
                    </div>
                  </Col>
                  <Col style={{ paddingLeft: '0px' }} sm={2}>
                    <Button
                      style={{ marginTop: '10px', padding: '6px 10px' }}
                      color='info'
                      onClick={() => {
                        setLimit(10);
                        setCurrentPage(1);
                        handleSearch();
                      }} // Trigger search
                    >
                      <SearchIcon />
                    </Button>
                  </Col>
                {!isSearched &&  <Col
                    sm={4}
                    className='d-flex justify-content-end align-items-center'
                  >
                    <p
                      style={{
                        marginRight: '15px',
                        marginBottom: '0',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {currentPage * limit - (limit - 1)}-{currentPage * limit}
                    </p>
                    <IconButton style={{ outline: 'none' }}>
                      {currentPage > 1 ? (
                        <KeyboardArrowLeftSharpIcon
                          style={{ color: '#fff' }}
                          onClick={() => {
                            setIsPrev(true);
                            setCurrentPage(currentPage - 1);
                          }}
                        />
                      ) : (
                        ''
                      )}
                    </IconButton>

                    {hasNextPage ? (
                      <IconButton style={{ outline: 'none' }}>
                        <KeyboardArrowRightSharpIcon
                          style={{ color: '#fff' }}
                          onClick={() => {
                            setIsPrev(false);
                            setCurrentPage(currentPage + 1);
                          }}
                        />
                      </IconButton>
                    ) : (
                      ''
                    )}
                    <select
                      className='form-control'
                      onChange={(e) => {
                        setIsPrev(false);
                        setLimit(parseInt(e.target.value));
                        setCurrentPage(1);
                      }}
                      style={{
                        maxWidth: '67px',
                        height: '40px',
                        color: '#fff', // White text
                        borderRadius: '4px',
                        marginLeft: '10px',
                      }}
                    >
                      <option value={10}>10</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>
                  </Col>}
                </Row>

                {/* Mock Table */}
                {quizDate?.length > 0 ? (
                  <Table className='tablesorter'>
                    <thead className='text-primary'>
                      <tr>
                        <th style={{ width: '50px', textAlign: 'center' }}>
                          <input
                            type='checkbox'
                            checked={allCheckedQuiz}
                            onChange={(e) => handleSelectAllQuizzes(e.target.checked)}
                            style={{ cursor: 'pointer', width: '18px', height: '18px' }}
                          />
                        </th>
                        <th>Name</th>
                        <th style={{ textAlign: 'center' }}>
                          Question <br /> Count
                        </th>
                        <th style={{ textAlign: 'center' }}>Price</th>
                        <th style={{ textAlign: 'center' }}>Assign </th>
                        <th style={{ textAlign: 'center' }}>
                          Attempted Users{' '}
                        </th>
                        <th style={{ textAlign: 'center' }}>
                          positive <br /> Marks{' '}
                        </th>
                        <th style={{ textAlign: 'center' }}>
                          negative <br /> Marks{' '}
                        </th>
                        <th>createdBy</th>
                        <th style={{ textAlign: 'center' }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {quizDate.map((quiz, index) => (
                        <tr key={index}>
                          <td style={{ width: '50px', textAlign: 'center' }}>
                            <input
                              type='checkbox'
                              checked={selectedQuizzes.includes(quiz.id)}
                              onChange={(e) => handleSelectQuiz(quiz.id, e.target.checked)}
                              style={{ cursor: 'pointer', width: '18px', height: '18px' }}
                            />
                          </td>
                          <td style={{ width: 150 }}>{quiz.name}</td>
                          <td style={{ width: 150, textAlign: 'center' }}>
                            {quiz?.quizQuestions?.length +
                              ' / ' +
                              quiz?.numberOfQuation}
                          </td>
                          <td style={{ width: 150, textAlign: 'center' }}>
                            ₹ {quiz.price || 0}
                          </td>
                          <td style={{ width: 150 }}>
                            <button
                              onClick={() => {
                                setAssignQuizData({
                                  isOpen: true,
                                  quizName: quiz?.name,
                                  studentRemoved: quiz?.studentRemoved || [],
                                  quizId: quiz?.id,
                                });
                              }}
                              style={{
                                background: 'transparent',
                                width: 'fit-content',
                                border: '0',
                                color: '#277CF7',
                                margin: '0 auto',
                                display: 'block',
                                cursor: 'pointer',
                                outline: 'none',
                                fontWeight: 'bold',
                              }}
                            >
                              Assign
                            </button>
                          </td>
                          <td>
                            <button
                              onClick={() => {
                                if (quiz?.attemptedUser?.length > 0)
                                  setAttemptedUserListState({
                                    isOpen: true,
                                    quizName: quiz?.name,
                                    quizId: quiz?.id,
                                  });
                              }}
                              style={{
                                background: 'transparent',
                                width: 'fit-content',
                                border: '0',
                                color: '#277CF7',
                                // color: 'white',
                                margin: '0 auto',
                                display: 'block',
                                cursor: 'pointer',
                                outline: 'none',
                                fontWeight: 'bold',
                              }}
                            >
                              {quiz?.attemptedUser?.length || 0}
                            </button>
                          </td>
                          <td style={{ width: 150, textAlign: 'center' }}>
                            {quiz?.positiveMarks || 'Not Set'}
                          </td>
                          <td style={{ width: 150, textAlign: 'center' }}>
                            {quiz?.negativeMarks || 'Not Set'}
                          </td>
                          <td>
                            {quiz?.isTeacher ? quiz.creatorName : 'Admin'}
                          </td>
                          <td style={{ textAlign: 'end' }}>
                            <div
                              style={{
                                display: 'flex',
                                flexWrap: 'nowrap',
                                justifyContent: 'center',
                              }}
                            >
                              <button
                                style={{
                                  marginRight: '7px',
                                  color: 'white',
                                  border: '0',
                                  padding: '0 ',
                                  outline: 'none',
                                  background: 'transparent',
                                }}
                                onClick={() => {
                                  handleNavigateToQuizQuestion(
                                    quiz?.id,
                                    quiz?.name,
                                    quiz,
                                  );
                                }}
                              >
                                <VisibilityIcon
                                  style={{ color: '#296ff6' }}
                                  sx={{
                                    opacity: currentUser?.isTeacher
                                      ? currentUser?.createdBy == quiz.createdBy
                                        ? '1.0'
                                        : '0.5'
                                      : '1.0',
                                    cursor: currentUser?.isTeacher
                                      ? currentUser?.createdBy == quiz.createdBy
                                        ? 'pointer'
                                        : ''
                                      : 'pointer',
                                  }}
                                />
                              </button>

                              <button
                                style={{
                                  marginRight: '7px',
                                  color: 'white',
                                  border: '0',
                                  padding: '0 ',
                                  outline: 'none',
                                  background: 'transparent',
                                }}
                                disabled={
                                  currentUser?.isTeacher
                                    ? currentUser?.createdBy !== quiz.createdBy
                                    : false
                                }
                                onClick={() => {
                                  handleEditQuiz(quiz);
                                }}
                              >
                                <Edit
                                  style={{ color: '#296ff6' }}
                                  sx={{
                                    opacity: currentUser?.isTeacher
                                      ? currentUser?.createdBy == quiz.createdBy
                                        ? '1.0'
                                        : '0.5'
                                      : '1.0',
                                    cursor: currentUser?.isTeacher
                                      ? currentUser?.createdBy == quiz.createdBy
                                        ? 'pointer'
                                        : ''
                                      : 'pointer',
                                  }}
                                />
                              </button>

                              <button
                                style={{
                                  color: 'white',
                                  border: '0',
                                  padding: '0 ',
                                  outline: 'none',
                                  background: 'transparent',
                                }}
                                disabled={
                                  currentUser?.isTeacher
                                    ? currentUser?.createdBy !== quiz.createdBy
                                    : false
                                }
                                onClick={(e) => {
                                  deleteQuizHandler(quiz.id);
                                }}
                              >
                                <Delete
                                  style={{ color: 'red' }}
                                  sx={{
                                    opacity: currentUser?.isTeacher
                                      ? currentUser?.createdBy == quiz.createdBy
                                        ? '1.0'
                                        : '0.5'
                                      : '1.0',
                                    cursor: currentUser?.isTeacher
                                      ? currentUser?.createdBy == quiz.createdBy
                                        ? 'pointer'
                                        : ''
                                      : 'pointer',
                                  }}
                                />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                ) : (
                  <>
                    {!loading && (
                      <div
                        style={{
                          textAlign: 'center',
                          fontSize: '18px',
                          fontWeight: 'bold',
                          padding: '20px',
                          border: '1px solid #ddd',
                          borderRadius: '8px',
                          marginTop: '20px',
                        }}
                      >
                        {searchQuery
                          ? 'Mock Not Found For This Search'
                          : '  No Mock Available'}
                      </div>
                    )}
                  </>
                )}
              </CardBody>
            )}
          </Card>
        </Col>
      </Row>
      <AddQuizModal
        isTeacher={currentUser?.isTeacher}
        fetchSubject={fetchSubject}
        isOpen={isAddQuizModalOpen}
        toggleModal={toggleAddQuizModalModal}
        saveQuiz={handleSaveQuiz}
      />

      {attemptedUserListState?.isOpen && (
        <AttemptedUserList
          attemptedUserListState={attemptedUserListState}
          handleClose={() =>
            setAttemptedUserListState({
              isOpen: false,
              quizId: '',
              quizName: '',
            })
          }
        />
      )}

      {assignQuizData?.isOpen && (
        <Dialog
          fullScreen
          open={assignQuizData?.isOpen}
          onClose={() =>
            setAssignQuizData({ isOpen: false, quizName: '', quizId: '' })
          }
          TransitionComponent={Transition}
        >
          <AssignQuiz
            currentUser={currentUser}
            assignQuizData={assignQuizData}
            handleClose={() =>
              setAssignQuizData({ isOpen: false, quizName: '', quizId: '' })
            }
          />
        </Dialog>
      )}

      {isEditQuizModalOpen && (
        <EditQuizModal
          isTeacher={currentUser?.isTeacher}
          isOpen={isEditQuizModalOpen}
          toggleModal={toggleEditQuizModal}
          updateQuiz={updateQuiz}
          quizToEdit={quizToEdit}
        />
      )}
      {/* Render Modal */}
      {isViewQuestionModalOpen && (
        <ViewQuestionModal
          question={selectedQuestion}
          isOpen={isViewQuestionModalOpen}
          toggleModal={() => toggleViewModal({})}
        />
      )}
    </div>
  );
}

export default CreateExcelQuestionV2;
